import httpClient from '@/services/httpClient'

export const getNewFirebaseToken = (): Promise<string> => {
  return httpClient
    .get('/integration/app-paciente/usuario/refresh-firebase-token')
    .then(res => res.data.object)
}

export const getFirebaseToken = (): Promise<string> => {
  return httpClient.get('/usuario/firebase-token').then(res => res.data.object)
}
